import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { ID, DELETE_REASON, DELETE_COMMENT, usePlanningActions, useAlerts } from 'store/planning';
import TextArea from 'components/TextAreaNew';
import Confirm from 'components/Confirm';
import { DELETE_REASONS } from '../../utils';

import { Title, Container, Wrapper, Button, Message } from './styles';

const DeleteSection = ({ patientId, sort, loading }) => {
  const [data, setData] = useState({});
  const { removePatientFromSchedule } = usePlanningActions();
  const { action, loading: removeLoading, success, error } = useAlerts(removePatientFromSchedule);
  const onSelect = useCallback(({ currentTarget }) => setData(($) => ({ ...$, [DELETE_REASON]: currentTarget.value })), []);
  const onChange = useCallback((v) => setData(($) => ({ ...$, [DELETE_COMMENT]: v })), []);
  const onDelete = useCallback(() => action({ [ID]: patientId, sort, ...data }), [patientId, action, sort, data]);
  const disabled = Boolean(loading || removeLoading || success);

  return (
    <>
      <Title>Registrierung löschen</Title>
      <Container>
        <Wrapper>
          {DELETE_REASONS.map(({ id, label }) => (
            <Button key={id} value={id} onClick={onSelect} isActive={data[DELETE_REASON] === id} disabled={disabled}>
              {label}
            </Button>
          ))}
        </Wrapper>
        <TextArea value={data[DELETE_COMMENT] || ''} onChangeText={onChange} disabled={disabled} />
      </Container>
      <Confirm title="Löschen" onClick={onDelete} width="200px" disabled={disabled || !data[DELETE_REASON]} />
      {error && <Message>{error}</Message>}
    </>
  );
};

DeleteSection.defaultProps = { loading: false };
DeleteSection.propTypes = {
  patientId: PropTypes.string.isRequired,
  sort: PropTypes.shape({
    sortBy: PropTypes.string.isRequired,
    sortDir: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
};

export default DeleteSection;
